const breadcrumbs = {
  '': 'Home',
  'dashboard': 'Dashboard',
  'dictionary': 'Dictionary',
  'projects': 'Projects',
  'wps': 'WPS',
  'logs': 'Logs',
  'inspection-category': 'Inspection Categories',
  'people': 'People',
  'groups': 'Groups',
  'reports': 'Reports',
  'work-progress': 'Work progress',
  'project-defectiveness': 'Project defectiveness',
  'welder-defectiveness': 'Welder defectiveness',
  'completion-forecast': 'Completion forecast',
  'defectiveness-trend': 'Defectiveness trend',
  'welder-benchmark': 'Welder benchmarking',
  'inspection-backlog': 'Inspection backlog',
  'section-progress': 'Section progress',
  'wps-usage': 'WPS usage',
  'repair-analysis': 'Repair analysis',
  'daily-burn-rate': 'Daily burn rate',
  'manual': 'Manual',
  'welders': 'Welders',
  'calculators': 'Calculators',
  'weldability-of-steel': 'Weldability of steel',
  'material-amount': 'Material amount',
  'companies': 'Companies',
  'profile': 'Profile',
}

export default breadcrumbs



// WEBPACK FOOTER //
// ./src/breadcrumbs.js